<template>
    <UserQuiz
        :show-title="false"
        :find-many-action-name="findManyActionName"
        :route-name-quiz-detail="routeNameQuizDetail"
        :school-id="schoolId"
        :school="school">
        <template v-slot:header>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link tag="a" :to="{ name: 'school.index' }">School</router-link></li>
                <li class="breadcrumb-item"><router-link tag="a" :to="{ name: 'school.user' }">{{school.name}}</router-link></li>
                <li class="breadcrumb-item">Quiz</li>
            </ol>
        </template>
    </UserQuiz>
</template>

<script>
import UserQuiz from "@/views/quizzes/user/Index";

export default {
    name: "school-quiz-index",

    components: {
        UserQuiz
    },

    data() {
        return {
            findManyActionName: 'quiz/schoolQuizFindMany',
            routeNameQuizDetail: 'school.quiz.detail',
            schoolId: this.$route.params.id,
            school: {},
        };
    },

    mounted () {
        this.getSchool();
    },

    methods: {

        getSchool () {

            this.$store.dispatch('school/findBySchool', this.schoolId)
                .then((res) => {
                    this.school = res.data.data
                })
                .catch(() => {
                })
        },
    }
}
</script>
